import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'
import moment from 'moment'
const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const testsSlice = createSlice({
    name: 'tests',
    initialState: {
        data: [],
        details: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {
        resetDetails: (state) => {
            if (state.details == null) {
                state.details = ''
            } else {
                state.details = null
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDetailsTests.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchDetailsTests.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.details = action.payload
            })
            .addCase(fetchDetailsTests.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(fetchTests.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchTests.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchTests.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createTest.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createTest.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createTest.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deleteTest.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deleteTest.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deleteTest.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchTests = createAsyncThunk(
    'tests/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/qualite.test.load?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch tests')
        }
    }
)
// Async thunk action to fetch details from the API
export const fetchDetailsTests = createAsyncThunk(
    'Tests/fetchDetails',
    async (id) => {
        const data = id.id
        try {
            const Test = await BaseService.get(
                `/XML/qualite.test.load/details?id=${data}`
            )
            Test.data.test.dateFormat = moment(Test.data.test.date).format('DD/MM/YYYY')
            Test.data.test.ordre_production = 'OP-' + Test.data.test.id_ordre
            Test.data.test.numero = Test.data.ordre.numero

            return Test.data
        } catch (error) {
            throw new Error('Failed to fetch Tests')
        }
    }
)
export const createTest = createAsyncThunk(
    'tests/post',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/qualite.test.send/add', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                navigate('/Qualite/Tests')
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)

export const editTest = createAsyncThunk('tests/edit',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/qualite.test.send/edit', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                navigate('/Qualite/Tests')
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    })

export const deleteTest = createAsyncThunk(
    'test/delete',
    async (payload) => {
        const { data, setTestAdded } = payload

        try {
            const response = await BaseService.post('/XML/qualite.test.send/delete', data)
            if (response.status === 200) {


                popNotification(creation?.success)
                setTestAdded(true)
            }
        } catch (err) {
            console.log({ err })
            

            
            popNotification(creation?.error)
        }
    }
)

export const selectData = (state) => state.tests.data
export const selectIsLoading = (state) => state.tests.isLoading
export const selectError = (state) => state.tests.error
export const selectIsDeleted = (state) => state.tests.isDeleted
export const selectCurrentPage = (state) => state.tests.currentPage
export const resetDetails = testsSlice.actions.resetDetails
export default testsSlice.reducer
